import { createSignal } from "solid-js";

/**
 * Open state of the ⌘K command palette (FLOW-798). Module-level for the same
 * reason as chatDrawerStore: AppShell is mounted per route, and the header
 * trigger, the shell key handler and the palette itself all read one signal.
 *
 * The query lives here too (FLOW-858): the shell's document-level Escape
 * handler owns the palette's two-stage clear-then-close behavior so it works
 * regardless of where focus is, not just while the input is focused, and
 * that requires reading and clearing the same query the palette renders.
 */
const [commandPaletteOpen, setCommandPaletteOpen] = createSignal(false);
const [paletteQuery, setPaletteQuery] = createSignal("");

export {
  commandPaletteOpen,
  setCommandPaletteOpen,
  paletteQuery,
  setPaletteQuery,
};
